import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { 
  RespuestaApi, 
  ResPersona, 
  ResRegistro,
  ResPadron,
} from '../models/index';

@Injectable({
  providedIn: 'root'
})
export class ResidentesService {
  private ENDPOINT = environment.ENDPOINTS.API;
  private ENDPOINTRESPERSONA = environment.ENDPOINTS.RES_PERSONA;
  private ENDPOINTRESPADRON = environment.ENDPOINTS.RES_PADRON;
  private ENDPOINTRESREGISTRO = environment.ENDPOINTS.RES_RESGISTRO;
  constructor(private http: HttpClient) { }

  getPersonas(): Promise<RespuestaApi<ResPersona[]>> {
    return this.http.get<RespuestaApi<ResPersona[]>>(this.ENDPOINTRESPERSONA).toPromise();
  }

  
  getPersonaById(id: number): Promise<RespuestaApi<ResPersona>> {
    return this.http.get<RespuestaApi<ResPersona>>(`${this.ENDPOINTRESPERSONA}/${id}`).toPromise();
  }

  
  crearPersona(persona: ResPersona): Promise<RespuestaApi<ResPersona>> {
    return this.http.post<RespuestaApi<ResPersona>>(this.ENDPOINTRESPERSONA, persona).toPromise();
  }

  
  actualizarPersona(id: number, persona: Partial<ResPersona>): Promise<RespuestaApi<ResPersona>> {
    return this.http.put<RespuestaApi<ResPersona>>(`${this.ENDPOINTRESPERSONA}/${id}`, persona).toPromise();
  }

 
  eliminarPersona(id: number): Promise<RespuestaApi<any>> {
    return this.http.delete<RespuestaApi<any>>(`${this.ENDPOINTRESPERSONA}/${id}`).toPromise();
  }

  
  getPadron(): Promise<RespuestaApi<any[]>> {
    return this.http.get<RespuestaApi<any[]>>(this.ENDPOINTRESPADRON).toPromise();
  }

  
  getPadronById(id: number): Promise<RespuestaApi<ResPadron>> {
    return this.http.get<RespuestaApi<ResPadron>>(`${this.ENDPOINTRESPADRON}/${id}`).toPromise();
  }

  
  buscarPadronPorTarjeta(noTarjeta: string): Promise<RespuestaApi<ResPadron[]>> {
    return this.http.get<RespuestaApi<ResPadron[]>>(`${this.ENDPOINTRESPADRON}/tarjeta/${noTarjeta}`).toPromise();
  }

  
  crearPadron(padron: Partial<ResPadron>): Promise<RespuestaApi<ResPadron>> {
    return this.http.post<RespuestaApi<ResPadron>>(this.ENDPOINTRESPADRON, padron).toPromise();
  }

  
  actualizarPadron(id: number, padron: Partial<ResPadron>): Promise<RespuestaApi<ResPadron>> {
    return this.http.put<RespuestaApi<ResPadron>>(`${this.ENDPOINTRESPADRON}/${id}`, padron).toPromise();
  }


  
  getPreRegistros(todos: boolean = false): Promise<RespuestaApi<ResRegistro[]>> {
    return this.http.get<RespuestaApi<ResRegistro[]>>(this.ENDPOINTRESREGISTRO).toPromise();
  }

  getPreRegistroById(id: number): Promise<RespuestaApi<ResRegistro>> {
    return this.http.get<RespuestaApi<ResRegistro>>(`${this.ENDPOINTRESREGISTRO}/${id}`).toPromise();
  }

  
  crearPreRegistro(registro: Partial<ResRegistro>): Promise<RespuestaApi<ResRegistro>> {
    return this.http.post<RespuestaApi<ResRegistro>>(this.ENDPOINTRESREGISTRO, registro).toPromise();
  }

  
  actualizarPreRegistro(id: number, registro: Partial<ResRegistro>): Promise<RespuestaApi<ResRegistro>> {
    return this.http.put<RespuestaApi<ResRegistro>>(`${this.ENDPOINTRESREGISTRO}/${id}`, registro).toPromise();
  }


  marcarProcesadosBatch(ids: number[]): Promise<RespuestaApi<{ actualizados: number }>> {
    return this.http.post<RespuestaApi<{ actualizados: number }>>(
      `${this.ENDPOINTRESREGISTRO}/marcar-procesados`,
      { ids }
    ).toPromise();
  }
}
